import { List, Stack, Text } from "@mantine/core";
import classNames from "classnames";
import type { BasicConfirmationModalProps } from "../BasicConfirmationModal/BasicConfirmationModal";
import { BasicConfirmationModal } from "../BasicConfirmationModal/BasicConfirmationModal";
import "./DeleteConfirmationModal.scss";

interface DeleteConfirmationModalProps extends BasicConfirmationModalProps {
  name: string;
  headerName?: string;
  modalBodyElement?: BasicConfirmationModalProps["children"];
  items?: string[];
}

function DeleteConfirmationModal({
  className,
  name,
  error,
  items,
  headerName,
  modalBodyElement,
  ...confirmationModalProps
}: DeleteConfirmationModalProps) {
  function getHeaderText() {
    const nameInHeaderText = headerName ? headerName : name;

    if (error) {
      return `${nameInHeaderText} kann nicht gelöscht werden`;
    }

    return `${nameInHeaderText} löschen`;
  }

  return (
    <BasicConfirmationModal
      className={classNames("DeleteConfirmationModal", className)}
      confirmationButtonColor="error"
      confirmationButtonText="Ja, löschen"
      error={error}
      title={getHeaderText()}
      onCancel={confirmationModalProps.toggleModal}
      {...confirmationModalProps}
    >
      {modalBodyElement ? (
        modalBodyElement
      ) : (
        <Stack gap="md">
          <Text>
            Sind Sie sicher, dass Sie <b>{name}</b> löschen möchten?
          </Text>
          {items && items.length > 0 && (
            <List>
              {items?.map((item, i) => (
                <List.Item key={item + i}>{item}</List.Item>
              ))}
            </List>
          )}
          <Text>Dieser Schritt kann nicht rückgängig gemacht werden.</Text>
        </Stack>
      )}
    </BasicConfirmationModal>
  );
}

export { DeleteConfirmationModal, DeleteConfirmationModalProps };
